const STATUS = /^[a-z_]{1,80}$/
export function isMsgraphReturn(location) {
  return location?.pathname === '/me/settings' && STATUS.test(new URLSearchParams(location.search).get('msgraph_personal') || '')
}

/** Admin's return fragment is a status hint, never proof of a connection. */
export function captureMsgraphReturn(win) {
  if (!win.location.hash.startsWith('#/settings/me?')) return false
  const params = new URLSearchParams(win.location.hash.slice('#/settings/me?'.length))
  const status = params.get('msgraph_personal')
  if (!STATUS.test(status || '')) return false
  win.history.replaceState(null, '', `/me/settings?msgraph_personal=${encodeURIComponent(status)}`)
  return true
}

export function isSafeConsentReturn(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return false
  const url = new URL(value, 'https://console.invalid')
  return url.origin === 'https://console.invalid' && (url.pathname === '/oauth/consent' || isMsgraphReturn(url))
}
